import styled from "styled-components";

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
`;

export const OverviewBlock = styled.div`
  margin-bottom: 32px;
`;

export const OverviewRow = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr;
  grid-gap: 8px;
  padding: 2px 0;
`;

export const TitleSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
